export function playerTitle(pageName?: string) {
  if (pageName) return `${pageName} | UpSwing Golf`
  return `UpSwing Golf`
}
